import { activePage, replaceActivePage } from "./pages";
import type { EngineDocument } from "../scene/model";
import { assertNativeDocument } from "./document";
export type PageUnit = "px" | "mm" | "cm";
export const pixelsPerUnit = (unit: string) =>
  unit === "mm" ? 96 / 25.4 : unit === "cm" ? 96 / 2.54 : 1;
export function displayMeasurement(px: number, unit: string) {
  return String(
    Number((px / pixelsPerUnit(unit)).toFixed(unit === "px" ? 0 : 2)),
  );
}
export function applyPage(
  document: EngineDocument,
  size: { width: number; height: number },
  unit: string,
  color: string,
) {
  if (
    ![size.width, size.height].every(
      (v) => Number.isFinite(v) && v >= 1 && v <= 16384,
    ) ||
    !["px", "mm", "cm"].includes(unit) ||
    !/^#[0-9a-f]{6}$/i.test(color)
  )
    throw new Error("Введите размер от 1 до 16384 px и корректный цвет.");
  const result = replaceActivePage(document, {
    ...activePage(document),
    size: {
      width: Math.round(size.width),
      height: Math.round(size.height),
    },
    unit,
    workspaceColor: color.toLowerCase(),
  });
  assertNativeDocument(result);
  return result;
}
